import { component } from 'picoapp'
import Drawer from '../lib/drawer';

export default component((node, ctx) => {

    const drawer = Drawer(node, node.parentNode);
    const closeDrawerBtn = node.querySelector('[data-close-linked-drawer]');
    const openDrawerBtn = document.querySelector('[data-open-linked-drawer]');

    closeDrawerBtn.addEventListener('click', () => {
        drawer.close();
    });

    openDrawerBtn.addEventListener('click', () => {
        drawer.open();
    });
    
})

